import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import Vuetify from "vuetify";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import {
  GENERATE_PDF_CONSTANTS,
  METHODS
} from "./constants/generate-pdf.contants";
import SelectDnD from "./components/SelectDnD/SelectDnD.vue";
import { TemplatePdfService } from "@/modules/TemplatePdf/services/templatePdfService";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { TemplatePdf } from "@/modules/TemplatePdf/Models/templatePdf";
import EmptyState from "@/shared/components/EmptyState/EmptyState.vue";
import { FieldGroup } from "@/modules/InfoGroup/models/FieldGroup";
import { Service } from "@/modules/Services/models/Service";
import { SectionGroupDetail } from "@/modules/ServiceTemplate/models/SectionGroupDetail";
import { Http } from "@status/codes";
import { GENERAL_CONSTANTS, STATE } from "@/shared/constants/GeneralConstants";
import { FORM_MESSAGES } from "@/shared/constants/FormConstants";
import { TEMPLATE_PDF_ACCESS } from "@/modules/TemplatePdf/constants/TemplatePdfConstants";
import { FormTemplateService } from "@/modules/FormTemplate/services/FormTemplateService";
import ModifVJsfInput from "../../../../shared/components/ModifVJsfInput/ModifVJsfInput.vue";
import { Field } from "@/modules/Forms/models/Field";

Vue.use(Vuetify);
@Component({
  name: "GeneratePdf",
  components: {
    SelectDnD,
    EmptyState,
    ModifVJsfInput
  }
})
export default class GeneratePdf extends Vue {
  @Inject() templatePdfService!: TemplatePdfService;
  @Inject() formTemplateService!: FormTemplateService;
  fieldsSelected: { [form: string]: string[] } = {};

  @Prop({ default: false }) public dialog!: boolean;
  @Prop() private data!: Service;
  @Prop({ default: [] }) public doctorInfoId!: string;
  @Prop({ default: [] }) public patientInfoId!: string;
  @Prop({ default: [] }) public sectionGroupDetail!: SectionGroupDetail[];

  cardClass = STYLE_CLASSES.CARD;
  btnClassPrimaryRound = STYLE_CLASSES.BASIC_ROUND_BTN;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  secBtnClass = STYLE_CLASSES.SECONDARY_BTN;
  primaryBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  CANCEL_BTN = GENERATE_PDF_CONSTANTS.BUTTON.CANCEL;
  ACCEPT_BTN = GENERATE_PDF_CONSTANTS.BUTTON.ACCEPT;
  LABEL_MEDICAL_CONSULTATION =
    GENERATE_PDF_CONSTANTS.LABELS.MEDICAL_CONSULTATION;
  LABEL_INFO_GROUP = GENERATE_PDF_CONSTANTS.LABELS.INFO_GROUP;
  INFO_PATIENT_TITLE = GENERATE_PDF_CONSTANTS.TITLES.INFO_PATIENT;
  TITLE = GENERATE_PDF_CONSTANTS.TITLES.TITLE;
  DOCTOR_INFO_TITLE = GENERATE_PDF_CONSTANTS.TITLES.DOCTOR_INFO;
  SELECT_FORMS_TITLE = GENERATE_PDF_CONSTANTS.TITLES.SELECT_FORMS;
  EMPTY_TITLE = GENERATE_PDF_CONSTANTS.TITLES.EMPTY_TITLE;
  templatePdfs: TemplatePdf[] = [];
  formsSelected: {
    name: string;
    id: string;
    form: string;
  }[] = [];
  templatePdf: TemplatePdf = {} as TemplatePdf;
  choosenFieldsPatient: FieldGroup[] = [];
  choosenFieldsDoctor: FieldGroup[] = [];
  errors = {
    templatePdf: false,
    choosenFieldsPatient: false,
    choosenFieldsDoctor: false,
    formsSelected: false
  };
  formsService = this.sectionGroupDetail;
  fieldsForm = {
    id: "",
    fields: []
  };
  checkdForms: { [form: string]: boolean } = {};

  async mounted() {
    try {
      const response = await this.templatePdfService.getDataInitial({
        state: STATE.ACTIVE
      });

      this.createFormsObject();

      if (response.code !== Http.Found || !response.data) {
        return Snackbar.popError(
          GENERATE_PDF_CONSTANTS.MESSAGES.ERROR_GET_TEMPLATES_PDF
        );
      }
      this.templatePdfs = response.data.pdfTemplateList;
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${TEMPLATE_PDF_ACCESS.GET}`
          : GENERATE_PDF_CONSTANTS.MESSAGES.ERROR_GET_TEMPLATES_PDF;

      Snackbar.popError(errorMessage);
    }
  }

  createFormsObject() {
    this.formsService.forEach((item: SectionGroupDetail) => {
      this.fieldsSelected[item.form!] = [];
    });
  }

  convertFieldsToArray(fields: Field[]): Field[] {
    const arrayDeObjetos: Field[] = [];

    for (const field in fields) {
      arrayDeObjetos.push({ ...fields[field], key: field });
    }

    return arrayDeObjetos;
  }

  toggleSelectAllFields(element: SectionGroupDetail): void {
    if (element.fields) {
      const fields = this.convertFieldsToArray(element.fields);
      const keys = fields.map(field => field.key);
      const allSelected = keys.every(key =>
        this.fieldsSelected[element.form!].includes(key)
      );

      if (allSelected) {
        keys.forEach(key => {
          const index = this.fieldsSelected[element.form!].indexOf(key);
          if (index !== -1) {
            this.$delete(this.fieldsSelected[element.form!], index);
          }
        });
      } else {
        keys.forEach(key => {
          if (!this.fieldsSelected[element.form!].includes(key)) {
            this.fieldsSelected[element.form!].push(key);
          }
        });
      }
    }

    const form = this.formsService.filter(form => element.form === form.form);
    this.choosenForm(form[0]);
  }

  choosenForm(formSelected: SectionGroupDetail) {
    if (!this.formsSelected.find(item => item.form === formSelected.form)) {
      this.formsSelected.push(
        formSelected as { name: string; id: string; form: string }
      );
    }

    if (!formSelected.fields) return;

    const fields = this.convertFieldsToArray(formSelected.fields);
    const fieldsSelecteds = this.fieldsSelected[formSelected.form!];

    if (fieldsSelecteds) {
      const allFieldsSelected = fieldsSelecteds.length === fields.length;
      this.checkdForms[formSelected.id] = allFieldsSelected;
    } else {
      this.checkdForms[formSelected.id] = false;
    }

    this.errors.formsSelected = false;
  }

  updateChoosenFieldsPatient(fields: FieldGroup[]) {
    this.choosenFieldsPatient = fields;
    this.errors.choosenFieldsPatient = false;
  }

  updateChoosenFieldsDoctor(fields: FieldGroup[]) {
    this.choosenFieldsDoctor = fields;
    this.errors.choosenFieldsDoctor = false;
  }

  validateObject() {
    if (Object.values(this.templatePdf).length === 0) {
      this.errors.templatePdf = true;
      Snackbar.popWarning(
        GENERATE_PDF_CONSTANTS.MESSAGES.TEMPLATE_PDF_REQUIRED
      );
      return true;
    }
    if (Object.values(this.choosenFieldsPatient).length === 0) {
      this.errors.choosenFieldsPatient = true;
      Snackbar.popWarning(GENERATE_PDF_CONSTANTS.MESSAGES.IG_PATIENT_REQUIRED);
      return true;
    }
    if (Object.values(this.choosenFieldsDoctor).length === 0) {
      this.errors.choosenFieldsDoctor = true;
      Snackbar.popWarning(GENERATE_PDF_CONSTANTS.MESSAGES.IG_DOCTOR_REQUIRED);
      return true;
    }
    if (Object.values(this.formsSelected).length === 0) {
      this.errors.formsSelected = true;
      Snackbar.popWarning(
        GENERATE_PDF_CONSTANTS.MESSAGES.FORMS_SELECTED_REQUIRED
      );
      return true;
    }
  }

  accept() {
    const validation = this.validateObject();
    if (validation) return;
    this.$emit(METHODS.CLOSE_MODAL, false);
    this.$emit(
      METHODS.OPEN_PREVIEW,
      false,
      this.templatePdf._key || this.templatePdf.id,
      this.choosenFieldsPatient,
      this.choosenFieldsDoctor,
      this.formsSelected,
      this.data,
      this.fieldsSelected
    );
  }

  cancel() {
    this.$emit(METHODS.CLOSE_MODAL);
  }
}
